import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  small: ['16px', '16px'],
  smallX: ['18px', '18px'],
  middle: ['24px', '24px'],
  large: ['32px', '32px'],
  huge: ['64px', '64px'],
};

const DownIcon = ({ size, style, shouldPadding, ...other }) => {
  size = typeof size === 'string' ? sizes[size] : size;
  const [width, height] = size;

  const svgProps = {
    width,
    height,
    style: Object.assign(shouldPadding ? { padding: '4px' } : {}, style),
    ...other,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      strokeWidth="2"
      {...svgProps}
    >
      <path
        d="M11.2929 16.7071L4.22185 9.63606C3.83132 9.24554 3.83132 8.61237 4.22185 8.22185C4.61237 7.83133 5.24554 7.83133 5.63606 8.22185L12 14.5858L18.364 8.22185C18.7545 7.83132 19.3877 7.83132 19.7782 8.22185C20.1687 8.61237 20.1687 9.24554 19.7782 9.63606L12.7071 16.7071C12.3166 17.0977 11.6834 17.0977 11.2929 16.7071Z"
        fill="currentColor"
      />
    </svg>
  );
};
DownIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
};
DownIcon.propTypes = {
  size: PropTypes.oneOf(['small', 'smallX', 'middle', 'large', 'huge']),
  shouldPadding: PropTypes.bool,
};

export default DownIcon;
